var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  require("!!vue-style-loader?{\"sourceMap\":false}!css-loader?{\"sourceMap\":false,\"minimize\":true,\"importLoaders\":1,\"alias\":{\"/assets\":\"/opt/nodeapps/svndata/jzq-web/assets\",\"/static\":\"/opt/nodeapps/svndata/jzq-web/static\"}}!../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-3d0e07e3\",\"scoped\":true,\"hasInlineConfig\":true}!less-loader?{\"sourceMap\":false}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./authorization.vue")
}
var normalizeComponent = require("!../../node_modules/vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader?{\"babelrc\":false,\"cacheDirectory\":false,\"presets\":[[\"/opt/nodeapps/svndata/jzq-web/node_modules/babel-preset-vue-app/dist/index.common.js\",{\"targets\":{\"ie\":9,\"uglify\":true}}]]}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./authorization.vue"
import __vue_script__ from "!!babel-loader?{\"babelrc\":false,\"cacheDirectory\":false,\"presets\":[[\"/opt/nodeapps/svndata/jzq-web/node_modules/babel-preset-vue-app/dist/index.common.js\",{\"targets\":{\"ie\":9,\"uglify\":true}}]]}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./authorization.vue"
/* template */
import __vue_template__ from "!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-3d0e07e3\",\"hasScoped\":true,\"transformToRequire\":{\"video\":\"src\",\"source\":\"src\",\"object\":\"src\",\"embed\":\"src\"},\"preserveWhitespace\":false,\"buble\":{\"transforms\":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./authorization.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3d0e07e3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "pages/signSettings/authorization.vue"

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3d0e07e3", Component.options)
  } else {
    hotAPI.reload("data-v-3d0e07e3", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./pages/signSettings/authorization.vue
// module id = F/5n
// module chunks = 214